import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { getCustomerNameOrPhone } from "@/customer/utils";
import InfoPair from "./info-pair";
import { NameAndDate, NameAndDateSkeleton } from "./name-and-date";
import type { ReferralContentProps } from "./referralContent";

export const InProgressReferralCardSkeleton = () => (
  <Stack align="start" gap={4} className="p-4">
    <NameAndDateSkeleton />
    <Stack align="start" gap={2}>
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-48" />
    </Stack>
  </Stack>
);

export const InProgressReferralCardContent = ({
  referral,
  onLost,
  onMoveToPaid,
  onDelete,
}: ReferralContentProps) => (
  <Stack align="start" gap={4} className="p-4">
    <NameAndDate
      referral={referral}
      hideDate
      onLost={onLost}
      onMoveToPaid={onMoveToPaid}
      onDelete={onDelete}
    />
    <Stack align="start" gap={2}>
      <InfoPair label="Services" info={referral.service_needed} />
      <InfoPair
        label="Referred by"
        info={getCustomerNameOrPhone(referral.advocate)}
      />
    </Stack>
  </Stack>
);
